module.exports = __webpack_public_path__ + "img/tag_best-seller.f77cf0c1.png";